import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'knowledgeBaseFilter',
    pure: false,
    standalone: false
})
export class KnowledgeBaseFilterPipe implements PipeTransform {
  transform(items: Array<any>, searchText: string, searchTags: Array<string>): Array<any> {

    items = items.filter((item: any) => {
      return (item.title.toLowerCase().includes(searchText.toLowerCase()) || item.description.toLowerCase().includes(searchText.toLowerCase()) || item.content.toLowerCase().includes(searchText.toLowerCase())) ? item : '';
    });

    if (searchTags && !searchTags.includes('All')) {
      searchTags = searchTags.map((t: string) => t.toLowerCase());

      items = items.filter((item: any) => {
        if (item.tags && item.tags.split(',').length > 0) {
          let itemTags = item.tags.split(',').map((t: string) => t.toLowerCase().trim());
          itemTags = itemTags.filter((iTag: string) => searchTags.includes(iTag));
          if (itemTags.length > 0) return item;
        }
      });
    }

    return items;

  }
}







